<script>
import BlogCourseSinglePagesComponent from '../features/lists/BlogCourseSinglePagesComponent';
import CouseSectionsView from '../boxes/CourseSectionsView';
import ModalCoursePromotionalVideoView from '../../courses/views/modals/ModalCoursePromotionalVideoView';
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';

export default {
  name: 'BlogCourseSinglePageView',
  components: {
        'brand-logo': BrandLogo,
    'course-sections-view': CouseSectionsView,
    'modal-course-promotional-video-view': ModalCoursePromotionalVideoView,
    'footer-view': FooterView,
  },
  extends: BlogCourseSinglePagesComponent,
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Course Hero -->
    <section
      v-if="item"
      class="public-hero course-hero"
    >
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <router-link to="/cursos">Cursos</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >{{ item.current.title }}</a>
        </nav>
        <h1 class="public-hero__title">{{ item.current.title }}</h1>
        <p class="public-hero__subtitle">{{ item.current.description }}</p>
      </div>
    </section>

    <!-- Course Content -->
    <main
      v-if="item"
      class="course-detail-body"
    >
      <div class="container">
        <!-- Preview + Info Row -->
        <div class="course-detail-card">
          <div class="row">
            <!-- Video Preview -->
            <div class="col-lg-5 col-md-6">
              <div
                v-if="item.current"
                class="course-preview"
              >
                <a
                  href="#"
                  class="course-preview__img"
                  data-toggle="modal"
                  data-target="#videoModal"
                >
                  <img
                    :src="mapCourseImageUrl(item.current.coverImageUrl)"
                    :alt="item.current.title"
                  >
                  <div
                    v-if="hasPromotionalVideo()"
                    class="course-preview__overlay"
                    @click="onShowPromotionalVideo"
                  >
                    <span class="play-btn"><i class="uil uil-play" /></span>
                    <span class="play-label">Ver Video</span>
                  </div>
                  <div
                    v-else
                    class="course-preview__overlay"
                  />
                </a>
              </div>
            </div>

            <!-- Course Info -->
            <div
              v-if="item.current"
              class="col-lg-7 col-md-6"
            >
              <div class="course-info">
                <h2 class="course-info__title">{{ item.current.title }}</h2>
                <p class="course-info__description">{{ item.current.description }}</p>

                <div class="course-info__stats">
                  <div class="course-info__stat">
                    <i class="uil uil-users-alt" />
                    <span>{{ item.current.totalEnrolled }} Estudiante(s)</span>
                  </div>
                  <div class="course-info__stat">
                    <i class="uil uil-tag" />
                    <span>{{ mapTags(item.current.tags) }}</span>
                  </div>
                  <div
                    v-if="item.current.lastUpdate"
                    class="course-info__stat"
                  >
                    <i class="uil uil-clock" />
                    <span>Última actualización: {{ item.current.lastUpdate }}</span>
                  </div>
                </div>

                <!-- Author -->
                <div
                  v-if="item.current.author"
                  class="course-info__author"
                >
                  <div class="author-avatar">
                    <img
                      :src="getProfileImage(item.current.author)"
                      alt=""
                    >
                  </div>
                  <div class="author-info">
                    <span class="author-label">Instructor</span>
                    <span class="author-name">{{ item.current.author.firstName }} {{ item.current.author.lastName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="course-tabs-wrapper">
          <div class="course_tabs">
            <nav>
              <div
                id="nav-tab"
                class="nav nav-tabs course-tab-nav"
                role="tablist"
              >
                <a
                  id="nav-about-tab"
                  class="nav-item nav-link active"
                  data-toggle="tab"
                  href="#nav-about"
                  role="tab"
                  aria-selected="true"
                >
                  <i class="uil uil-info-circle" /> Acerca del Curso
                </a>
                <a
                  id="nav-courses-tab"
                  class="nav-item nav-link"
                  data-toggle="tab"
                  href="#nav-courses"
                  role="tab"
                  aria-selected="false"
                >
                  <i class="uil uil-list-ul" /> Contenido
                </a>
                <a
                  id="nav-instructors-tab"
                  class="nav-item nav-link"
                  data-toggle="tab"
                  href="#nav-instructors"
                  role="tab"
                  aria-selected="false"
                >
                  <i class="uil uil-book-open" /> Profesores
                </a>
              </div>
            </nav>
          </div>

          <!-- Tab Content -->
          <div
            id="nav-tabContent"
            class="tab-content course-tab-content"
          >
            <!-- About Tab -->
            <div
              id="nav-about"
              class="tab-pane fade show active"
              role="tabpanel"
            >
              <div
                v-if="item.current"
                class="course-about"
              >
                <h3>Acerca del Curso</h3>
                <div
                  class="description"
                  v-html="item.current.about"
                />
              </div>
            </div>

            <!-- Content Tab -->
            <div
              v-if="item.current"
              id="nav-courses"
              class="tab-pane fade"
              role="tabpanel"
            >
              <div class="course-content-section">
                <h3>Contenido de Curso</h3>
                <div class="course-content-meta">
                  <el-col
                    :xs="6"
                    :sm="6"
                    :md="4"
                    :lg="2"
                    :xl="2"
                    align="center"
                  >
                    <span class="_fgr123">
                      {{ item.current.getDuration() }}<small>(Min)</small>
                    </span>
                  </el-col>
                </div>
                <course-sections-view
                  :course-details="item.current"
                />
              </div>
            </div>

            <!-- Instructors Tab -->
            <div
              v-if="item.current"
              id="nav-instructors"
              class="tab-pane fade"
              role="tabpanel"
            >
              <div class="course-instructors">
                <h3>Profesores</h3>
                <el-row>
                  <el-col
                    v-for="instructor in item.current.instructors"
                    :key="instructor.id"
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                    :xl="8"
                    class="block"
                  >
                    <div class="instructor-card">
                      <div class="instructor-card__avatar">
                        <img
                          :src="mapProfileImageUrl(instructor.userProfile)"
                          alt=""
                        >
                      </div>
                      <div class="instructor-card__content">
                        <div class="instructor-card__name">
                          {{ instructor.userProfile.firstName }} {{ instructor.userProfile.lastName }}
                          <i
                            class="uil uil-check-circle verified-badge"
                            title="Verificado"
                          />
                        </div>
                        <el-popover
                          width="400"
                          placement="right"
                          trigger="click"
                        >
                          <div>
                            <h4>Acerca</h4>
                            <p>{{ instructor.about }}</p>
                          </div>
                          <br>
                          <div>
                            <h4>Especialidad</h4>
                            <p>{{ instructor.educationSpecialty }}</p>
                          </div>
                          <br>
                          <div>
                            <h4>Redes Sociales</h4>
                            <br>
                            <ul class="tutor_social_links">
                              <li>
                                <a
                                  v-if="hasFacebookPage(instructor)"
                                  :href="instructor.pageUrlFacebook"
                                  class="fb"
                                  target="_blank"
                                ><i class="fab fa-facebook-f" /></a>
                              </li>
                              <li>
                                <a
                                  v-if="hasInstagramPage(instructor)"
                                  :href="instructor.pageUrlInstagram"
                                  class="in"
                                  target="_blank"
                                >
                                  <i class="fab fa-instagram" />
                                </a>
                              </li>
                              <li>
                                <a
                                  v-if="hasLinkedinPage(instructor)"
                                  :href="instructor.pageUrlLinkedIn"
                                  class="ln"
                                  target="_blank"
                                >
                                  <i class="fab fa-linkedin-in" />
                                </a>
                              </li>
                            </ul>
                          </div>
                          <template #reference>
                            <el-button link>
                              Ver más...
                            </el-button>
                          </template>
                        </el-popover>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>

        <!-- Course Navigation -->
        <div class="course-nav">
          <div class="row">
            <div class="col-md-6">
              <a
                v-if="item.preview"
                class="course-nav-link course-nav-link--prev course-pointer"
                @click="navigate(item.preview)"
              >
                <div class="course-nav-icon">
                  <i class="uil uil-angle-left" />
                </div>
                <div class="course-nav-text">
                  <span class="course-nav-label">Anterior</span>
                  <span class="course-nav-title">{{ item.preview.title }}</span>
                </div>
              </a>
            </div>
            <div class="col-md-6">
              <a
                v-if="item.next"
                class="course-nav-link course-nav-link--next course-pointer"
                @click="navigate(item.next)"
              >
                <div class="course-nav-text course-nav-text--right">
                  <span class="course-nav-label">Siguiente</span>
                  <span class="course-nav-title">{{ item.next.title }}</span>
                </div>
                <div class="course-nav-icon">
                  <i class="uil uil-angle-right" />
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- Back -->
        <div class="course-back">
          <router-link
            to="/cursos"
            class="btn-outline"
          >
            <i class="uil uil-arrow-left" /> Ver todos los cursos
          </router-link>
        </div>
      </div>
    </main>

    <!-- Video Modal -->
    <modal-course-promotional-video-view
      v-if="modalItemCoursePromotionalVideo && modalItemCoursePromotionalVideo.isVisible"
      :conf="modalItemCoursePromotionalVideo"
      :form-data="item ? item.current : null"
    />

    <footer-view />
  </div>
</template>

<style scoped>
.course-hero {
  padding: 40px 24px 36px;
}

.course-hero .public-hero__title {
  font-size: clamp(1.4rem, 2.5vw, 1.8rem);
}

.course-hero .public-hero__subtitle {
  margin-top: 8px;
  font-size: 0.9375rem;
  max-width: 700px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course-detail-body {
  flex: 1;
  background: #f0f4f8;
  padding: 40px 24px;
}

/* Preview Card */
.course-detail-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.course-preview {
  border-radius: 10px;
  overflow: hidden;
}

.course-preview__img {
  position: relative;
  display: block;
  overflow: hidden;
}

.course-preview__img img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.course-preview:hover .course-preview__img img {
  transform: scale(1.02);
}

.course-preview__overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
}

.play-btn {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-btn i {
  font-size: 24px;
  color: #0D47A1;
  margin-left: 4px;
}

.play-label {
  color: #fff;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
}

/* Course Info */
.course-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.course-info__title {
  font-family: 'Roboto', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px;
  line-height: 1.3;
}

.course-info__description {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 20px;
}

.course-info__stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.course-info__stat {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  color: #475569;
}

.course-info__stat i {
  color: #0D47A1;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.course-info__author {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.author-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.author-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.author-label {
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #0D47A1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.author-name {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0f172a;
}

/* Tabs */
.course-tabs-wrapper {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.course-tab-nav {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0 16px;
  gap: 0;
}

.course-tab-nav .nav-item {
  padding: 14px 20px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.course-tab-nav .nav-item i {
  font-size: 16px;
}

.course-tab-nav .nav-item:hover {
  color: #0D47A1;
  background: #EEF5FC;
}

.course-tab-nav .nav-item.active {
  color: #0D47A1;
  font-weight: 600;
  border-bottom-color: #0D47A1;
  background: #fff;
}

.course-tab-content {
  padding: 24px;
}

/* About */
.course-about h3 {
  font-family: 'Roboto', sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px;
}

.course-about :deep(.description) {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9375rem;
  color: #334155;
  line-height: 1.8;
}

.course-about :deep(.description p) {
  margin: 0 0 1em;
}

.course-about :deep(.description h1),
.course-about :deep(.description h2),
.course-about :deep(.description h3) {
  color: #0f172a;
  margin: 1.5em 0 0.75em;
}

.course-about :deep(.description ul),
.course-about :deep(.description ol) {
  margin: 0 0 1em 1.5em;
}

.course-about :deep(.description li) {
  margin-bottom: 0.5em;
}

.course-about :deep(.description img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1em 0;
}

/* Content */
.course-content-section h3 {
  font-family: 'Roboto', sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px;
}

.course-content-meta {
  margin-bottom: 20px;
}

.course-content-meta :deep(.el-col) {
  padding: 8px;
}

.course-content-meta :deep(._fgr123) {
  display: inline-block;
  background: #EEF5FC;
  color: #0D47A1;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 20px;
}

/* Instructors */
.course-instructors h3 {
  font-family: 'Roboto', sans-serif;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 20px;
}

.instructor-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  gap: 14px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
}

.instructor-card:hover {
  background: #EEF5FC;
  border-color: #c3d7f0;
}

.instructor-card__avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.instructor-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.instructor-card__content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.instructor-card__name {
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 6px;
}

.verified-badge {
  color: #22c55e;
  font-size: 18px;
}

.tutor_social_links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
}

.tutor_social_links li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  text-decoration: none;
}

.tutor_social_links li a.fb { background: #3b5998; }
.tutor_social_links li a.in { background: #e1306c; }
.tutor_social_links li a.ln { background: #0077b5; }

/* Navigation */
.course-nav {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.course-nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.course-nav-link:hover {
  background: #EEF5FC;
}

.course-nav-link--next {
  justify-content: flex-end;
  text-align: right;
}

.course-nav-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #EEF5FC, #D6E7F8);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.course-nav-icon i {
  font-size: 18px;
  color: #0D47A1;
}

.course-nav-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.course-nav-text--right {
  text-align: right;
}

.course-nav-label {
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #0D47A1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.course-nav-title {
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Back */
.course-back {
  text-align: center;
  margin-bottom: 24px;
}

.course-back .btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  padding: 10px 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .course-detail-body {
    padding: 24px 16px;
  }

  .course-info {
    padding-top: 16px;
  }

  .course-tab-nav .nav-item {
    padding: 10px 12px;
    font-size: 0.8125rem;
  }
}
</style>
